/* StationsModal.js */
import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { Box, useTheme } from '@mui/material';
import CustomTextArea from 'components/Fileds/CustomTextArea';

const CollectionSchema = Yup.object().shape({
    name: Yup.string().required('Station Name is required'),
    // notes: Yup.string().required('Notes is required'),
});

const StationsModal = ({ open, onClose, initialData, onSubmit, loading }) => {
    const isEdit = Boolean(initialData);
    const title = isEdit ? 'Edit Station' : 'Add Station';
    const theme = useTheme();
    return (
        <GenericDialog
            open={open}
            onClose={onClose}
            title={title}
            initialValues={{
                name: initialData?.name || '',
                notes: initialData?.notes || ''
            }}
            validationSchema={CollectionSchema}
            onSubmit={onSubmit}
            submitLabel={isEdit ? 'Update' : 'Save'}
            loading={loading}
            requiredFields={[ 'name' ]}
        >
            {({ values, errors, touched, handleChange, handleBlur }) => (
                <>
                    <Box sx={{ mb: '20px' }}>
                        <CustomTypography
                            label="Station Name"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        <CustomTextField
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            placeholder="Enter Station Name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                        />
                    </Box>
                    <Box>
                        <CustomTypography
                            label="Notes"
                            sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                        />
                        <CustomTextArea
                            name="notes"
                            value={values.notes}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            multiline
                            rows={2}
                            // height={"100%"}
                            placeholder="Enter Notes"
                        
                        />
                    </Box>
                </>
            )}
        </GenericDialog>
    );
};

export default StationsModal;
